function SearchBar()
{
    // Focus input on search show
    const searchBar = document.getElementById('search-bar');
    if (searchBar === null) {
        return; 
    }

    searchBar.addEventListener('shown.bs.offcanvas', event => {
        const searchInput = searchBar.querySelector('input[type=text].form-control');
        if (searchInput !== null) { 
            requestAnimationFrame(() => {
                setTimeout(() => {
                    searchInput.focus();
                }, 0)
            });
        }   
    });
}

export default SearchBar;